module.exports = __webpack_public_path__ + "static/img/companybg2.0edaca3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/companybg2.png
// module id = /4rT
// module chunks = 0